import { createApp } from 'vue/dist/vue.esm-bundler.js';

import VueSweetalert2 from 'vue-sweetalert2';

const SwalOptions = {
    showCancelButton: true,
    buttonsStyling: false,
    customClass: {
        content: 'rte',
        htmlContainer: 'rte',
        confirmButton: 'button button--hollow',
        cancelButton: 'button button--primary',
    }
};

// App imports.
import diaperRiskWidgetApp from './vue/nomograms/diaperRisk.js';
import erectileFunctionWidgetApp from './vue/nomograms/erectileFunction.js';
import lutsWidgetApp from './vue/nomograms/luts.js';
import survivalWidgetApp from './vue/nomograms/survival.js';
import questionnaireEmbedApp from './vue/questionnaireEmbed';

document.addEventListener('DOMContentLoaded', () => {
    // Mounting containers listing and DOM targeting.
    const diaperRiskWidgetContainers = document.querySelectorAll('.widget-diaper-risk');
    const erectileFunctionWidgetContainers = document.querySelectorAll('.widget-erectile-function');
    const lutsWidgetContainers = document.querySelectorAll('.widget-luts');
    const survivalWidgetContainers = document.querySelectorAll('.widget-survival');
    const questionnaireEmbedContainer = document.getElementById('questionnaire-embed');

    diaperRiskWidgetContainers.forEach(container => {
        createApp(diaperRiskWidgetApp).mount(container);
    });

    erectileFunctionWidgetContainers.forEach(container => {
        createApp(erectileFunctionWidgetApp).mount(container);
    });

    lutsWidgetContainers.forEach(container => {
        createApp(lutsWidgetApp).mount(container);
    });

    survivalWidgetContainers.forEach(container => {
        createApp(survivalWidgetApp).mount(container);
    });

    if (questionnaireEmbedContainer) {
        const app = createApp(questionnaireEmbedApp);
        app.use(VueSweetalert2, SwalOptions);
        app.mount(questionnaireEmbedContainer);
    }
});
